import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import API_URL from "../ApiUrl/ApiUrl";
import { Link } from "react-router-dom";
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${API_URL}/login`, {
        email,
        password,
      });

      if (response.status === 200) {
        toast.success("Login successful!", {
          position: "top-center",
        });
        setTimeout(() => {
          response?.data?.role === "admin"
            ? navigate("/software/dashboard")
            : navigate("/");
        }, 2000);
        localStorage.setItem("admin_token", response.data.token);
        localStorage.setItem("user_token", response.data.token);
        localStorage.setItem("firstname", response.data.firstname);
        localStorage.setItem("lastname", response.data.lastname);
      } else {
        toast.error("Invalid credentials. Please try again.", {
          position: "top-center",
        });
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again.",
        {
          position: "top-center",
        }
      );
    }
  };

  return (
    <div>
      <div
        className="transper"
        style={{ width: "100%", height: "100px" }}
      ></div>
      <ToastContainer />
      <div className="login-container">
        <div className="image-section">
          <div className="">
            <img
              src="https://i.ibb.co/FDtGqWt/cars1.png"
              alt="African woman in headwrap"
            />
          </div>
        </div>
        <div className="login-section">
          <div className="login-header">
            <h1>LOG IN</h1>
          </div>
          <form id="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">User Email</label>
              <input
                className="login"
                type="text"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                className="login"
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="submit-btn">
              SUBMIT
            </button>
            <p className="mt-4">
              {" "}
              Don't have an account?{" "}
              <Link to="/register">
                <span>Register</span>
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
